















































// vue
import { defineComponent, ref, Ref, computed } from '@vue/composition-api'

// componnents
import { PageHeader } from '@/components'
import { Modal } from '@/components/general'
import { InsuranceCompaniesTableList, InsuranceCompanyFormCreateEdit } from '@/components/config'

// services
import { InsuranceCompanyService } from '@/services/config'

// models
import { Paginator } from '@/models'
import { InsuranceCompany, InsuranceCompanyForm } from '@/models/config'

// utils
import { loading, alerts } from '@/utils'

// constants
import { actionFormTypes } from '@/constants'

const insuranceCompanyDefault: InsuranceCompanyForm = {
  name: '',
  is_active: true
}

export default defineComponent({
  name: 'InsuranceCompanyIndex',
  components: {
    PageHeader,
    InsuranceCompaniesTableList,
    Modal,
    InsuranceCompanyFormCreateEdit
  },
  setup () {
    const showModal = ref(false)
    const title = 'Compañia de Seguro'
    const actionForm = ref(actionFormTypes)
    const idEdit: Ref<number|null> = ref(null)
    const titleModal = computed(() => {
      if (actionForm.value === 'update') {
        return 'Editar Compañia de Seguros'
      }
      return 'Crear Compañia de Seguros'
    })
    const items = [
      {
        text: 'Dashboard'
      },
      {
        text: 'Compañia de Seguros',
        active: true
      }
    ]
    const pagination: Ref<Paginator> = ref({
        currentPage: 1,
        total: 0,
        count: 0,
        perPage: 10
    })
    const insuranceCompany: Ref<InsuranceCompanyForm> = ref(insuranceCompanyDefault)
    const insuranceCompanies: Ref<InsuranceCompany[]> = ref([])
    const getInsuranceCompaniesWithPagination = async () => {
      loading('show')
      const res = await InsuranceCompanyService.getWithPagination(pagination.value.perPage, pagination.value.currentPage)
      pagination.value = res.pagination
      insuranceCompanies.value = res.objects
      loading('hide')
    }
    getInsuranceCompaniesWithPagination()
    const addNew = () => {
      actionForm.value = 'save'
      showModal.value = true
      insuranceCompany.value = {
        ...insuranceCompanyDefault
      }
    }
    const saveSuccess = () => {
      showModal.value = false
      actionForm.value = 'save'
      insuranceCompany.value = {
        ...insuranceCompanyDefault
      }
      idEdit.value = null
      getInsuranceCompaniesWithPagination()
    }
    const editItem = (item: InsuranceCompany) => {
      insuranceCompany.value = {
        name: item.name,
        is_active: item.is_active
      }
      idEdit.value = Number(item.id)
      actionForm.value = 'update'
      showModal.value = true
    }

    const deleteItem = async (item: InsuranceCompany) => {
      const msg = `Seguro que desea eliminar la Compañia de Seguro: ${item.name}?`
      const confirm = await alerts.confirm(msg)
      if (confirm) {
        loading('show')
        await InsuranceCompanyService.delete(item.id)
        alerts.success()
        getInsuranceCompaniesWithPagination()
      }
    }

    const changePage = (page: number) => {
        pagination.value.currentPage = page
        getInsuranceCompaniesWithPagination()
    }

    const changePerPage = (perPage: number) => {
        pagination.value.perPage = perPage
        pagination.value.currentPage = 1
        getInsuranceCompaniesWithPagination()
    }

    return {
      items,
      title,
      addNew,
      showModal,
      titleModal,
      saveSuccess,
      deleteItem,
      idEdit,
      editItem,
      actionForm,
      pagination,
      changePage,
      changePerPage,
      insuranceCompany,
      insuranceCompanies
    }
  }
})
